import { Link } from "react-router-dom";
import { categories } from "@/mocks/site";

const footerLinks = [
  { label: "关于色虎", to: "/news" },
  { label: "影视资讯", to: "/news" },
  { label: "热门榜单", to: "/category/movie" },
  { label: "搜索影片", to: "/search?q=热门" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-900 text-primary-100">
      <div className="portal-container py-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg font-black text-primary-950">
                虎
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">色虎</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-7 text-primary-200">
              色虎是一个聚焦热门影视剧推荐与专业影视资讯的综合影视娱乐平台，帮助影迷快速发现好作品、掌握行业动态。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 rounded-md bg-primary-800 px-3 py-1.5 text-xs text-primary-200">
              <i className="ri-information-line" aria-hidden="true" />
              本站为演示站点，内容均为示例数据
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-[0.16em] text-accent-300">影视分类</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((item) => (
                <li key={item.key}>
                  <Link to={`/category/${item.key}`} className="text-primary-200 transition-colors hover:text-background-50">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-[0.16em] text-accent-300">站点导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {footerLinks.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="text-primary-200 transition-colors hover:text-background-50">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-[0.16em] text-accent-300">内容声明</h3>
            <p className="mt-4 text-sm leading-7 text-primary-200">
              站内影片、评分、资讯均为演示内容，不对应真实作品，亦不提供任何影片播放服务。分享功能仅调用浏览器能力与第三方分享页面。
            </p>
            <div className="mt-4 flex items-center gap-3 text-primary-300">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-800">
                <i className="ri-weibo-line" aria-hidden="true" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-800">
                <i className="ri-wechat-line" aria-hidden="true" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-800">
                <i className="ri-link" aria-hidden="true" />
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 色虎 Sehu Film. 保留所有权利。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>内容仅用于产品演示</span>
            <span className="hidden sm:inline text-primary-700">·</span>
            <span>影片信息与详情页一一对应</span>
            <span className="hidden sm:inline text-primary-700">·</span>
            <span>Made for film lovers</span>
          </p>
        </div>
      </div>
    </footer>
  );
}